// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","565":"component---src-templates-page-js","725":"component---src-templates-gallery-js"}[chunkId] || chunkId) + "-" + {"351":"24f911ae4e40df2796b4","565":"96a6128b2ddb84708851","725":"1f3f167512165e59c2d9","731":"c630501e759cb3f06436","843":"cff4afe7cadcd319a1bf"}[chunkId] + ".js";
};